import { Question } from './question.model';

export interface SurveySourceVariable {
  id: string;
  label: string;
  value: unknown;
  question: Question | null;
}
